import ReCAPTCHA from "react-google-recaptcha";
import { EnvVariables } from "../../utils/EnvVariables";
import { useRef } from "react";
const ReCaptchaComponent = ({ setCaptchaValue }) => {
  const recaptchaRef = useRef(null);

  const handleCaptchaReset = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setCaptchaValue(null);
    }
  };
  return (
    <>
      <div className="d-flex flex-direction-c gap-10">
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={EnvVariables.GOOGLE_RECAPTCHA_SITE_KEY}
          onChange={(value) => {
            setCaptchaValue(value);
          }}
          onExpired={() => {
            setCaptchaValue(null);
          }}
          className="mg-top-10"
          data-size="compact"
        />
      </div>
      <span
        className="forgot-link-container cp mg-top-10"
        onClick={handleCaptchaReset}
      >
        Refresh Captcha
      </span>
    </>
  );
};

export default ReCaptchaComponent;
